
import { Sale } from "@/models/base";
import { printHumanFloat } from "../../utils/pretty-print";
import Vue from "vue";
import { base64ToBlob, downloadBlob } from "@/utils/blob";
import { ClientPortalService } from "@/services/client-portal-service";
import { TranslateResult } from "vue-i18n";
import {i18n} from "@/setup/i18n-setup";

export default Vue.extend({
	filters: {
		printHumanFloat,
	},
	data() {
		return {
			token: "",
			showPayButton: false
		};
	},
	props: {
		invoice: {
			type: Object as ()=>Sale,
			required: true
		},
		open: {
			type: Boolean,
			required: false
		},
		canPay: {
			type: Boolean,
			required: false
		},
		canSign: {
			type: Boolean,
			required: false
		},
		showTotal: {
			type: Boolean,
			default: true
		},
		additional: {
			type: Boolean,
			default: false
		},
		info: {
			type: String,
			default: ""
		}
	},
	computed: {
		invoiceStatus():string{
			if (this.invoice.TotalOpen != 0) {
				return "<span class='open st'>" + this.$ct("invoice-status.unpaid").toString() + "</span>";
			}
			return "<span class='paid st'>" + this.$ct("invoice-status.paid").toString() + "</span>";
		},
		saleTypeName():string | TranslateResult{
			let defaultValue = this.$ct("Document");
			if (!this.invoice.Type) {
				return defaultValue;
			}
			return this.invoice.Type.Name.getTranslation(this.invoice.getLng()) || defaultValue;
		},
		computedFriendlyId():string {
			return this.invoice.getOriginalComputedFriendlyIDFromSaldoDocument();
		},
		isSigned():boolean {
			return this.invoice.SignatureImageToken != "";
		}
	},
	methods: {
		i18n() {
			return i18n;
		},
		parseTemplate(template:string, invoice: Sale) {
			const parsedTemplate = template.replace(/{{\s*(.*?)\s*}}/g, (_, match) => {
				try {
					return new Function("invoice", `return ${match}`)(invoice);
				} catch (error) {
					return "";
				}
			});
			return parsedTemplate;
		},
		onClick(){
			this.$emit("click");
		},
		async download():Promise<any> {
			let token = await ClientPortalService.getSalePublicToken(this.token, this.invoice.ID);
			let file = await ClientPortalService.downloadSaleAsBlob(token);
			downloadBlob(base64ToBlob(file.Data, file.MimeType), file.FileName);
		},
		async pay() {
			let token = await ClientPortalService.getSalePublicToken(this.token, this.invoice.ID);
			await ClientPortalService.paySale(token);
		},
		sign(){
			this.$emit("sign");
		}
	},
	mounted(){
		this.token = this.$route.params.token;
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
